import { useQueryClient } from 'react-query'
import { QueryKey } from 'config/constants/queryKey'
import { useUserBoostedFarmsInfos } from 'state/farmBoost/useUserBoostedFarmsInfos'
import { useUserMoleTokenIds } from 'state/minerMole/useUserMoleTokenIds'
import { getCraftsmanAddress } from 'utils/addressHelpers'
import { refreshFarmUserDataFromPid } from 'state/farms/useDeserializedFarmsUser'
import { getFarmVersionFromPid } from 'state/farms/farmsPidToVersion'
import { useCallback } from 'react'

const useInvalidateActualBoostFactor = (farmId, lpAddress) => {
  const queryClient = useQueryClient()

  const invalidatingActualBoostFactor = useCallback(() => {
    queryClient.invalidateQueries([QueryKey.TOKEN_BALANCE_QUERY, lpAddress, getCraftsmanAddress()])
    useUserBoostedFarmsInfos.getState().refresh()
    useUserMoleTokenIds.getState().refresh()
    refreshFarmUserDataFromPid(farmId, getFarmVersionFromPid(farmId))
  }, [farmId, lpAddress, queryClient])

  return { onInvalidatingActualBoostFactor: invalidatingActualBoostFactor }
}

export default useInvalidateActualBoostFactor
